import React, { Component } from 'react';
import Media from "react-media";
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { PRIORITY, STATUS } from './TicketsContainer.js';
import { SCREEN_WIDTH } from '../../App.js';
import { translate } from 'react-i18next';

class Tickets extends Component {
  //Prueba COMMIT

  getTicketLink = (ticket) => {
    return {
      pathname: "/ticket/" + ticket.id,
      state: {
        ticket: JSON.stringify(ticket)
      }
    };
  }

  renderTicket = (ticket, index) => {
    const date = moment(ticket.date, 'YYYY-MM-DD HH:mm:ss');
    let panelStyle;
    let status;
    let textStyle;
    const { t } = this.props;

    switch (ticket.priority) {
      default:
      case PRIORITY.LOW:
        panelStyle = "panel panel-info";
        break;
      case PRIORITY.MEDIUM:
        panelStyle = "panel panel-warning";
        break;
      case PRIORITY.HIGH:
        panelStyle = "panel panel-danger";
        break;
    }

    switch (ticket.status) {
      default:
      case STATUS.OPEN:
        status = t('dashboard.tickets.status_open');
        textStyle = "";
        break;
      case STATUS.CLOSED:
        panelStyle = "panel panel-default";
        status = t('dashboard.tickets.status_closed');
        textStyle = "text-muted";
        break;
    }

    return(
      <div className="col-md-6 col-lg-4" key={index}>
        <div className={panelStyle}>
          <div className="panel-heading">
            <span className={textStyle}>
              <h4 className="panel-title">{"Ticket " + ticket.id + ": " + status}</h4>
            </span>
          </div>
          <div className="panel-body">
            <p className={textStyle}>{ticket.description}</p>
          </div>
          <hr />
          <div className="panel-body">
            <span className={textStyle}>{ticket.center_name}</span>
          </div>
          <hr />
          <div className="panel-body">
            <span className={textStyle}>{date.format('dddd, LL')}</span>
          </div>
          <hr />
          <div className={ticket.manager_name ? "" : "hidden"}>
            <div className="panel-body">
              <span className={textStyle}>{"Asignado a " + ticket.manager_name}</span>
            </div>
          </div>
          <hr />
          <div className="panel-body">
            <center><Link to={this.getTicketLink(ticket)}>
              <button
                className="btn btn-primary"
                type="button">
                {t('dashboard.tickets.btn_info')}
              </button>
            </Link></center>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const tickets = this.props.tickets;
    return(
      <div>
        <Media query={"(min-width: " + SCREEN_WIDTH.LARGE + "px)"}>
          {(matches) =>
            matches ? (
              tickets.map((_, index) => !(index % 3) &&
                <div className="row" key={index}>
                  {this.renderTicket(tickets[index], index)}
                  {tickets[index + 1] && this.renderTicket(tickets[index + 1], index + 1)}
                  {tickets[index + 2] && this.renderTicket(tickets[index + 2], index + 2)}
                </div>
              )
            ) : (
              tickets.map((_, index) => !(index % 2) &&
                <div className="row" key={index}>
                  {this.renderTicket(tickets[index], index)}
                  {tickets[index + 2] && this.renderTicket(tickets[index + 1], index + 1)}
                </div>
              )
            )
          }
        </Media>
      </div>
    );
  }
}

export default translate('common')(Tickets);



// WEBPACK FOOTER //
// ./src/dashboard/tickets/Tickets.js